import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { exposeInitialWidgetLoadEvent } from '../../Helpers/events';
import { getSupplierMatchComponent } from '../../Helpers/supplierMatchPredicates';
import { SUBCATEGORY_MAX_MATCHES_DEFAULT } from '../../Helpers/supplierMatches';

const InitialWidgetLoadEventManager = () => {
  const { iFrameId, widgetLabel, haveAllInitialMessagesArrived } = useSelector(
    (store) => store.optionalFormConfig
  );
  const {
    subcategoryName,
    subcategoryId,
    categoryName,
    sectorName,
    categoryId,
    tradingHubId,
    tradingHubName,
    submissionPageNumber,
    phoneNumberCountryCode,
    formId,
    isPolarisForm,
  } = useSelector((store) => store.formConfig);
  const { visitorId } = useSelector((store) => store.userIdentities);
  const components = useSelector((store) => store.components);
  const { componentExperiments } = useSelector(
    (store) => store.experimentation
  );
  const { subcategoryMaxMatches } = useSelector(
    (store) => store.supplierMatches
  );

  useEffect(() => {
    if (haveAllInitialMessagesArrived === true) {
      const supplierMatchComponent = getSupplierMatchComponent({ components });
      const componentMaxMatches = supplierMatchComponent?.component?.maxMatches;
      const maxMatchesToUse =
        subcategoryMaxMatches ||
        componentMaxMatches ||
        SUBCATEGORY_MAX_MATCHES_DEFAULT;

      exposeInitialWidgetLoadEvent({
        currentPage: 0,
        components,
        iFrameId,
        widgetLabel,
        subcategoryName,
        subcategoryId,
        categoryName,
        categoryId,
        sectorName,
        tradingHubId,
        tradingHubName,
        visitorId,
        submissionPage: submissionPageNumber,
        phoneNumberCountryCode,
        componentExperiments,
        subcategoryMaxMatches: maxMatchesToUse,
        formId: formId !== undefined ? String(formId) : undefined,
        formOriginId: process.env.NEXT_PUBLIC_SUBMISSION_ORIGIN_ID,
        isPolarisForm,
      });
    }
  }, [haveAllInitialMessagesArrived]);

  return null;
};

export default InitialWidgetLoadEventManager;
